import React, { useRef, useState } from "react";

// MUI
import { ButtonBase, ButtonBaseProps } from '@mui/material';
import { TouchRippleActions } from '@mui/material/ButtonBase/TouchRipple';

const HoverRippleButtonBase = (props: ButtonBaseProps) => {
  const touchRippleRef = useRef<TouchRippleActions>(null);

  const [rippleActive, setRippleActive] = useState(false);

  const handleRipple = () => {
    if (!rippleActive) {
      setRippleActive(true);
      touchRippleRef.current?.start();
    }

    setTimeout(() => {
      touchRippleRef.current?.stop();
      setRippleActive(false);
    }, 200);
  };

  return (
    <ButtonBase
      {...props}
      sx={{
        textAlign: 'left',
        '& .MuiTouchRipple-root': {
          color: (theme) => `${theme.palette.primary.main}40`,
        },
      }}
      touchRippleRef={touchRippleRef}
      onMouseEnter={handleRipple}
      disableTouchRipple
    />
  );
};

export default HoverRippleButtonBase;